import { GoToMealsRequest } from "@/clients/models/GoToMealsRequest";
import { MealTime } from "@/clients/models/MealTime";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useSelectGotoMeals = (mealTime: MealTime) => {
  const mutation = useMutation({
    mutationKey: [QueryKeys.GO_TO_SELECT_MEAL, mealTime],
    mutationFn: async (requestBody: GoToMealsRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.setGotoMealsForMealTimeApiV1MealsGotoMealTimePost(
          mealTime,
          user.id,
          requestBody,
        );
      return data;
    },
  });
  return {
    selectGotoMeal: mutation.mutate,
    selectGotoMealAsync: mutation.mutateAsync,
    isSelecting: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    response: mutation.data,
  };
};
